module.exports = __webpack_public_path__ + "static/chunks/src/page-ottawa/part-why-replace/assets/image-cause-04.2a88761dd0104c454913d739c60027c3.webp";